import { Injectable } from '@angular/core';
import { ReportRow } from '@contracts';
import { BehaviorSubject, Observable, finalize, map, tap } from 'rxjs';
import { mapReportRows } from '../data-access/report.mapper';
import { ReportService } from '../data-access/report.service';
import { ReportQuery } from '../types/report.type';

@Injectable()
export class ReportFacade {
  private readonly _rows = new BehaviorSubject<ReportRow[]>([]);
  private readonly _loading = new BehaviorSubject<boolean>(false);

  readonly rows$ = this._rows.asObservable();
  readonly loading$ = this._loading.asObservable();

  constructor(private readonly reportService: ReportService) {}

  load(query?: ReportQuery): Observable<ReportRow[]> {
    this._loading.next(true);

    return this.reportService.getReport(query).pipe(
      map((response) => {
        if (response.meta.response_code !== 20000) {
          return [];
        }

        return mapReportRows(response.meta.response_data.value ?? []);
      }),
      tap((rows) => this._rows.next(rows)),
      finalize(() => this._loading.next(false)),
    );
  }
}
